import { createContext } from 'react';

// IP-15353: the row's Actions menu opens a status-change modal, and Kendo's cell
// contract only hands the component { dataItem }. Context supplies the tenant's
// status list and the mutation without rebuilding closures per row.
export default createContext({
  statuses: [],
  onChangeStatus: () => {}
});
